import React from 'react';
import Icon from '@bonprix/pattern-library/templates/icon';

export default function ResponsiveImage({alt, image, style, className, onLoad}) {
    if (!image || !image.isReadyForDisplay) {
        return (
            <div className="responsive-image__missing-image-container">
                <Icon className="wishlist-item__image" name="sold-out" />
            </div>
        );
    }
    const sources = image.imagePaths.map((path, index) => {
        return (
            <source
                key={index}
                media={'(' + path.mediaQuery + ')'}
                srcSet={path.plainPath + ' 1x, ' + path.retinaPath + ' 2x'}
                onLoad={onLoad}
            />
        );
    });
    const imageCssClass = 'responsive-image__picture-tag';
    return (
        <picture className={className ? `${imageCssClass} ${className}` : imageCssClass} style={style}>
            {sources}
            <img className="responsive-image__img-tag" src={image.defaultImagePath} alt={alt} onLoad={onLoad} />
        </picture>
    );
}
